"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/// <reference path="Parser.d.ts" />
var remark_1 = __importDefault(require("remark"));
var remark_rehype_1 = __importDefault(require("remark-rehype"));
var unist_util_visit_1 = __importDefault(require("unist-util-visit"));
// Adapted from
// * https://github.com/djm/remark-shortcodes/blob/master/index.js
// * https://using-remark.gatsbyjs.org/custom-components/
var delimitedParser = function (type, start, stop) {
    function parser(eat, value, silent) {
        var _a;
        if (!value.startsWith(start)) {
            return;
        }
        var stopPosition = value.indexOf(stop, start.length);
        if (stopPosition === -1) {
            return;
        }
        if (silent) {
            return true;
        }
        var tag = value.slice(0, stopPosition + stop.length);
        var inner = tag.slice(start.length, stopPosition);
        return eat(tag)((_a = { type: type }, _a[type] = inner, _a));
    }
    parser.locator = function (value, from) { return value.indexOf(start, from); };
    return parser;
};
function pibase() {
    var parser = this.Parser.prototype;
    parser.inlineTokenizers.citation = delimitedParser('citation', '{{', '}}');
    parser.inlineTokenizers.internalLink = delimitedParser('internalLink', '{', '}');
    parser.inlineTokenizers.inlineMathDollars = delimitedParser('inlineMath', '$', '$');
    parser.inlineTokenizers.inlineMathParens = delimitedParser('inlineMath', '\\(', '\\)');
    // It is important that the \(...\) tokenizer appears before the escape tokenizer
    //   but we might want to defer the others to later in the chain
    parser.inlineMethods.splice(parser.inlineMethods.indexOf('escape'), 0, 'citation', 'internalLink', 'inlineMathDollars', 'inlineMathParens');
    var transformer = function (tree) {
        unist_util_visit_1.default(tree, 'citation', function (node) {
            node.data = {
                hName: 'citation',
                hProperties: {
                    citation: node.citation
                }
            };
        });
        unist_util_visit_1.default(tree, 'inlineMath', function (node) {
            node.data = {
                hName: 'inlineMath',
                hProperties: {
                    inline: true,
                    formula: node.inlineMath
                }
            };
        });
        unist_util_visit_1.default(tree, 'internalLink', function (node) {
            node.data = {
                hName: 'internalLink',
                hProperties: {
                    to: node.internalLink
                }
            };
        });
    };
    return transformer;
}
exports.default = (function () {
    return remark_1.default()
        .use(pibase)
        .use(remark_rehype_1.default);
});
